import { MainProps, UI_Main } from 'ui/components/4-habitats/Main/Main';
import { Speaker } from '../../2-feature/Speaker/Speaker';
import { Breadcrumb } from '2-feature/Navgation/Breadcrumb';
import { usePageContext } from '3-foundation/PageContent/PageContext';
export const MainRegion = ({
	breadCrumb,
	header,
	localNavigation,
	localNavigationOnTop,
	withLocalNavigationArticleWidth,
	speaker,
	children,
}: MainProps) => {
	const pageContext = usePageContext();
	return (
		<UI_Main
			header={header}
			background={pageContext?.pageBackground}
			breadCrumb={breadCrumb === undefined ? <Breadcrumb /> : breadCrumb}
			localNavigation={localNavigation}
			localNavigationOnTop={localNavigationOnTop}
			withLocalNavigationArticleWidth={withLocalNavigationArticleWidth}
			speaker={speaker ? speaker : <Speaker />}
		>
			{children}
		</UI_Main>
	);
};
